import { FormRestructureEvent } from "../core/";

export const phonePattern = /(?:([+]\d{1,4})[-.\s]?)?(?:[(](\d{1,3})[)][-.\s]?)?(\d{1,4})[-.\s]?(\d{1,4})[-.\s]?(\d{1,9})/;
const partialPattern = /^([+]\d{0,4}[-.\s]?)?([(]?\d{0,3}[)]?[-.\s]?)?(\d{0,4}[-.\s]?){0,3}$/;
const allowedChars = /^[\d\s().\-+]*$/;

/**
 * @param {HTMLFormElement} form 
 */
export function addPhoneValidation(form) {
	form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

		for (const entry of event.added) {
			if (!entry.field) continue;
		
			/** @type {NodeListOf<HTMLInputElement>} */
			const inputs = entry.field.querySelectorAll(`:scope input[type="tel"]`);

			for (const input of inputs) {
				if (input.dataset.inputPhone !== "true") continue;

				input.addEventListener("beforeinput", ev => {
						const { data, inputType } = ev;

						if (inputType.startsWith("delete")) return;

						if (data != null && !allowedChars.test(data)) {
							ev.preventDefault();
							return;
						}

						const start = input.selectionStart ?? input.value.length;
						const end = input.selectionEnd ?? input.value.length;
						const value = input.value.slice(0, start) + data + input.value.slice(end);

						if (!partialPattern.test(value)) {
								ev.preventDefault();
						}
				});
			}

			//for (const input of inputs) {
			//	if (!input.dataset.valPhone) continue;
			//	
			//	input.addEventListener("blur", ev => {
			//			if (!phonePattern.test(input.value)) {
			//					input.setCustomValidity("Invalid phone number format.");
			//			} else {
			//					input.setCustomValidity("");
			//			}
			//	});
			//}
		}
	});
}